$.validator.addMethod("valueNotEquals", function(value, element, arg){
    return arg !== value;
}, "Please choose an option.");

$.validator.addMethod("ausphone", function(value, element) {
    return (this.optional(element) && value==="") || /^\({0,1}((0|\+61)(\ |-){0,1}(2|4|3|7|8)|(13|18)){0,1}\){0,1}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{1}(\ |-){0,1}[0-9]{3}$/.test(value);   // eslint-disable-line no-useless-escape
}, 'Please enter a valid Australian phone number');

$.validator.addMethod( "time", function( value, element ) {
    return this.optional( element ) || /^([01]\d|2[0-3]|[0-9])(:[0-5]\d){1,2}$/.test( value );
}, "Please enter a valid time, between 00:00 and 23:59" );

$.validator.addMethod( "integer", function( value, element ) {
    return this.optional( element ) || /^\d+$/.test( value );
}, "A positive non-decimal number please" );

$.validator.addMethod("checkStatus", function(value, element) {
    if ($('[name=Status]').val() === 'disposed') {
        return (value!=="");
    }
    return YourValidationCode; // return true if field is ok or should be ignored
}, "Please select a disposal date");

$.validator.addMethod("date", function(value, element) {
    return this.optional( element ) || /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test( value );
}, "Please enter a date");

// jQuery.validator.addMethod("greaterThanAttr",
//     function(value, element, params) {
//
//         var dateobj= moment(element.getAttribute('data-min'), "YYYY/MM/DD");
//         var valueobj = moment(value, "DD/MM/YYYY");
//         return (dateobj.isSameOrAfter(valueobj));
//     }, 'Date must be a future date.');
